/**
 * 模組名稱：MainFrame
 * 模組說明 : 前端主框架
 * @module MainFrame
 */

// ----- import from npm modules -----
import { Routes, Route, Navigate } from 'react-router-dom';

// ----- import from base components -----
import WebSocketManager from '../../components/WebSocketManager';
import {
  React,
  PropTypes,
  BaseComponent,
  bindActionCreators,
  connect,
  withTranslation,
} from '../../components/BaseComponent';

// ----- import from local components -----
import BuildingContainer from '../../modules/building';
import RolePermissionContainer from '../../modules/role-permission';
import ResidentContainer from '../../modules/resident';
import AccountManagementContainer from '../../modules/account-management';
import ElevatorContainer from '../../modules/elevator';
import ElevatorApplyContainer from '../../modules/elevator-apply';
import ElevCtrlHistoryContainer from '../../modules/elevator-control-history';
import ControlCodeContainer from '../../modules/control-code';

// ----- constants -----
const SOCKET_URL = process.env.REACT_APP_WEBSOCKET_URL;

class MainFrame extends BaseComponent {
    constructor(props) {
        super(props);
        this.sidebarRef = React.createRef();
        this.mainRef = React.createRef();
        this.webSocketManager = React.createRef();
        this.state = {
            sidebarClassName: 'sidebar',
            mainClassName: 'main',
            defaultModule: 'elevator-apply',
            newSocketMessage: null,
        };
        this.onSocketMessage = this.onSocketMessage.bind(this);
    }

    /**
     * 取得URL
     * @param {*} path 
     * @returns 
     */
    getUrl(path) {
        return path;
    }

    componentDidMount() {
        const { userPermissions } = this.props;
        const hasElevatorApplyPermission = userPermissions.some(permission => 
            permission.children.some(child => child.moduleName === '梯控申請')
        );

        if (!hasElevatorApplyPermission) {   
            const defaultModule = userPermissions[0]?.children[0]?.navigatePath || userPermissions[1]?.children[0]?.navigatePath || 'elevator';
            this.setState({ defaultModule: defaultModule });
        }
    }

    onSocketMessage = (message) => {
        const data = JSON.parse(message);
        console.log('onSocketMessage data:', data);
        // Check if the message is for this user
        console.log('this.props.userId:', this.props.userId);
        if (data.userId && Number(data.userId) === Number(this.props.userId)) {
            console.log('data.event:', data.event);
            if (data.event === 'disable_user' || data.event === 'update_user_role') {
                //this.props.userPermissions = [];
                window.location = this.getUrl('/permission-denied');
            } else if (data.event === 'update_user_password') {
                //this.props.userPermissions = [];
                window.location = this.getUrl('/notify-password-update');
            } else if (data.event === 'update_role_permission') {
                //this.props.userPermissions = [];
                window.location = this.getUrl('/notify-permission-update');
            }
        }

        this.setState({ newSocketMessage: data });
    }

    render() {
        return (
            <div>
                <Routes>
                    <Route path="/" element={<Navigate to={this.state.defaultModule} />} />
                    <Route path="elevator" element={<ElevatorContainer />} />
                    <Route path="elevator-apply" element={<ElevatorApplyContainer newSocketMessage={this.state.newSocketMessage} />} />
                    <Route path="elevator-control-history" element={<ElevCtrlHistoryContainer newSocketMessage={this.state.newSocketMessage} />} />
                    <Route path="building" element={<BuildingContainer newSocketMessage={this.state.newSocketMessage} />} />
                    <Route path="role-permission" element={<RolePermissionContainer />} />
                    <Route path="resident" element={<ResidentContainer />} />
                    <Route path="account-management" element={<AccountManagementContainer />} />
                    <Route path="control-code" element={<ControlCodeContainer />} />
                </Routes>
                <WebSocketManager
                    ref={this.webSocketManager}
                    url={SOCKET_URL}
                    onSocketMessage={this.onSocketMessage}
                />
            </div>
        );
    }
}

MainFrame.propTypes = {
    userPermissions: PropTypes.array,
};

MainFrame.defaultProps = {
    userPermissions: [],
};

function mapStateToProps(state) {
    return {
        userPermissions: state.access.userPermissions,
        userId: state.auth.userId,
    };
}

function mapDispatchToProps(dispatch) {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(MainFrame);